import React from "react";
import { TwitterTweetEmbed as Tweet } from "react-twitter-embed";

const TwitterTweetEmbed = ({ value }) => {
  if (!value?.tweetId) {
    return null;
  }

  return (
    <div className='my-8 flex justify-center w-full'>
      <div className='w-full max-w-[550px]'>
        <Tweet tweetId={value.tweetId} />
        {value.caption && (
          <p className='text-center font-rubik text-md  text-gray-500 mt-2'>
            {value.caption}
          </p>
        )}
      </div>
    </div>
  );
};

export default TwitterTweetEmbed;
